"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importStar)(require("styled-components"));
var input_1 = require("../input");
var counter_1 = require("./components/counter");
function Textarea(props) {
    var className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, fieldId = props.fieldId, height = props.height, innerRef = props.innerRef, inputId = props.inputId, invisible = props.invisible, _a = props.isCounted, isCounted = _a === void 0 ? false : _a, isInvalid = props.isInvalid, isRequired = props.isRequired, testId = props.testId, name = props.name, maxLength = props.maxLength, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, value = props.value, _b = props.disabledResize, disabledResize = _b === void 0 ? false : _b;
    var _c = (0, react_1.useState)(value != null ? value.length : 0), count = _c[0], setCount = _c[1];
    function handleChange(e) {
        if (e) {
            setCount(e.length);
        }
        if (onChange) {
            onChange(e);
        }
    }
    return (react_1.default.createElement("div", { id: fieldId },
        react_1.default.createElement(StyledTextArea, { className: className, defaultValue: defaultValue, disabled: disabled, fieldId: inputId, height: height, innerRef: innerRef, invisible: invisible, isInvalid: isInvalid, isRequired: isRequired, maxLength: maxLength, name: name, onBlur: onBlur, onChange: handleChange, onFocus: onFocus, placeholder: placeholder, type: "textarea", testId: testId, value: value, disabledResize: disabledResize }),
        isCounted && maxLength && react_1.default.createElement(counter_1.Counter, { length: count, maxLength: maxLength })));
}
exports.Textarea = Textarea;
var StyledTextArea = (0, styled_components_1.default)(input_1.Input)(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var disabledResize = _a.disabledResize;
    return disabledResize && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n      resize: none;\n    "], ["\n      resize: none;\n    "])));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map